import { defineComponent as t, createElementBlock as o, openBlock as r, createVNode as n, createTextVNode as a, unref as c } from "vue";
import { ScalarIconSignOut as u } from "@scalar/icons";
const l = {
  class: "header-item-link text-c-1 ml-auto flex",
  href: "/logout"
}, p = /* @__PURE__ */ t({
  __name: "HeaderLogoutButton",
  setup(m) {
    return (s, e) => (r(), o("a", l, [
      n(c(u)),
      e[0] || (e[0] = a(" Logout "))
    ]));
  }
});
export {
  p as default
};
